// extracted by mini-css-extract-plugin
export default {"headers":"header_headers__YAac6","title":"header_title__j5wSX","day":"header_day__ExxLl","menu":"header_menu__bsN3F","menu__item":"header_menu__item__iFQlE"};